import React from 'react';
import { Route, Switch } from 'react-router';

import Login from 'views/Login';
import RedirectLanding from 'views/RedirectLanding';
import RecoveryPass from 'views/RecoveryPass';
import CreateNewPassword from 'views/CreateNewPassword';
import SuccessRecoveryPass from 'views/SuccessRecoveryPass';
import Dashboards from 'views/Dashboards';
import Locals from 'views/Locals';
import TaskList from 'views/TaskList';
import TaskDetails from 'views/TaskDetails';
import ManageUser from 'views/ManageUser';

import ProtectedRoute from 'containers/ProtectedRoute';
import NoAuthRoute from 'containers/NoAuthRoute';

import { routes } from 'config/routes';

const Routes = () => (
  <Switch>
    <NoAuthRoute exact path={routes.redirect} component={RedirectLanding} />
    <Route exact path={routes.home} component={Login} />
    <Route exact path={routes.recovery} component={RecoveryPass} />
    <Route path={routes.confirmRecovery} component={SuccessRecoveryPass} />
    <Route path={routes.createNewPassword} component={CreateNewPassword} />
    <ProtectedRoute path={routes.dashboard} component={Dashboards} />
    <ProtectedRoute path={routes.locals} component={Locals} />
    <ProtectedRoute path={routes.taskDetails} component={TaskDetails} />
    <ProtectedRoute path={routes.taskList} component={TaskList} />
    <ProtectedRoute path={routes.manageUser} component={ManageUser} />
    <Route render={() => 404} />
    {/* Not found view */}
  </Switch>
);

export { routes };
export default Routes;
